import Title from "../miscellaneous/Title";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
import {Bar, BarChart, Legend, ResponsiveContainer, XAxis, YAxis} from "recharts";
import Tooltip from "recharts/lib/component/Tooltip";
import {makeStyles} from "@material-ui/core/styles";


const myStyles = makeStyles({
    root: {
        display: "flex",
        justifyContent: "space-between"
    },
    icon: {
        position: "absolute",
        right: "10"
    },
    tooltip: {
        zIndex: 10,
        border: "1px solid lightgrey",
        backgroundColor: "white",

    },
    div: {
        padding: "5px"
    },
    name: {
        padding: "5px",
        color: "#8884d8",
        textAlign: "center",
        backgroundColor: "lightgrey"
    }
});


export default function MyBarChart(props) {

    const classes2 = myStyles();


    return (
        <React.Fragment>
            <Title>
                <div className={classes2.root} style={{color:'#408033'}}>{props.title}

                </div>
            </Title>
            <ResponsiveContainer>
                <BarChart
                    width={500}
                    height={300}
                    data={props.data}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey={props.category1_solver1}  stackId="a" fill="#3D91E0" />
                    <Bar dataKey={props.category2_solver1} stackId="a" fill="#8ABDEC" />
                    {props.category3_solver1 === undefined ? null :<Bar dataKey={props.category3_solver1} stackId="a" fill="#c4def5" />}
                    <Bar dataKey={props.category1_solver2} stackId="b" fill="#408033" />
                    <Bar dataKey={props.category2_solver2} stackId="b" fill="#8cb284" />
                    {props.category3_solver1 === undefined ? null :<Bar dataKey={props.category3_solver2} stackId="b" fill="#b8cfb3" />}
                </BarChart>
            </ResponsiveContainer>
        </React.Fragment>
    )

}


